// All user-visible strings (Thai). Only the h1, the #beta chip, #about and the lang="en" paragraph live in index.html.
// Every control reads its label/copy from here — never a hardcoded Thai literal in main.js. Started from
// apps/coaster/src/strings.js (the upload, skipped-file and link texts are its own, said for a case).
// Phones are named as what the case fits (spec D19): plain text from phones.js, no logo, no picture of a device.
const S = {
  title: "เคสมือถือใส่ชื่อ",
  beta: "รุ่นทดลอง",
  phone: "รุ่นโทรศัพท์",
  forPhone: (name) => `เคสสำหรับ ${name}`,
  material: "วัสดุ",
  materials: {
    flex: "ยืดหยุ่น (TPU)",
    rigid: "แข็ง (PETG)",
  },
  thick: "ความหนา",
  thicks: {
    slim: "บาง",
    standard: "มาตรฐาน",
    tough: "หนา",
  },
  fit: "ความแน่น",
  fits: {
    tight: "แน่น",
    normal: "พอดี",
  },
  src: "ลายด้านหลัง",
  textHint: (lines, chars) => `ได้ถึง ${lines} บรรทัด บรรทัดละไม่เกิน ${chars} ตัวอักษร`,
  loadingFont: (family, got, total) => (total > 0 ? `กำลังโหลด ${family} ${got.toFixed(1)} / ${total.toFixed(1)} MB` : `กำลังโหลด ${family} ${got.toFixed(1)} MB`),
  finish: "แบบลาย",
  finishes: {
    flush: "เรียบ 2 สี",
  },
  turn: "ทิศทาง",
  turns: {
    "0": "แนวนอน",
    "90": "แนวตั้ง",
  },
  scale: "ขนาด",
  pos: "ตำแหน่ง",
  position: (v) => (Math.abs(v) < 0.005 ? 'กลาง' : `${v > 0 ? 'บน' : 'ล่าง'} ${Math.round(Math.abs(v) * 100)}%`),
  needFile: "เลือกไฟล์ SVG — ไฟล์อยู่ในเครื่องของคุณ ไม่ถูกส่งไปที่ใด",
  artKept: "ลายอยู่ในหน้านี้เท่านั้น — รีเฟรชหน้าแล้วต้องเลือกไฟล์ใหม่",
  keptOld: "(ยังใช้ลายเดิมอยู่)",
  thumb: "ตัวอย่างลายที่อ่านได้",
  shareNoArt: "ลิงก์นี้ไม่มีไฟล์ SVG — ผู้รับต้องเลือกไฟล์เอง",
  linkNeedsArt: "แบบนี้ใช้ลายจากไฟล์ ซึ่งไม่ได้มากับลิงก์ — เลือกไฟล์ SVG เพื่อใส่ลาย",
  gColour: "สี",
  colourCase: "สีเคส",
  colourArt: "สีลาย",
  notes: {
    untested: (name, material) => `ยังไม่ได้ทดสอบพิมพ์จริงสำหรับ ${name} ด้วย${material}`,
    settings: "พิมพ์คว่ำด้านหลังลงบนฐาน ไม่ใช้ซัพพอร์ต ความสูงชั้น 0.2 มม.",
    tested: (name, material) => `ทดสอบพิมพ์แล้วสำหรับ ${name} ด้วย${material}`,
    proud: (mm) => `เลนส์กล้องโผล่พ้นหลังเคส ${mm} มม. วางเครื่องหงายหลังบนโต๊ะแล้วจะโยก`,
    flush: "แบบเรียบ 2 สี ต้องใช้เครื่องพิมพ์หลายสี และไฟล์ 3MF (ไฟล์ STL ไม่มีลาย จึงปิดไว้)",
    engraved: "แบบเซาะร่อง ใช้สีเดียว ไม่ต้องเปลี่ยนเส้น ใช้ไฟล์ STL หรือ 3MF ก็ได้",
    pla: "ไม่แนะนำ PLA — แตกง่ายตอนสวมและอ่อนตัวเมื่อเครื่องร้อน ใช้ TPU หรือ PETG",
    terms: "ใช้เพื่อการเรียนรู้และใช้ส่วนตัว — ผู้ใช้รับความเสี่ยงเอง",
  },
  size: (x, y, z) => `ขนาดเคส ${x.toFixed(1)} × ${y.toFixed(1)} × ${z.toFixed(1)} มม.`,
  grams: (g) => `หนักประมาณ ${Math.round(g)} กรัม`,
  views: {
    back: "ด้านหลัง",
    front: "ด้านหน้า",
    side: "ด้านข้าง",
  },
  problem: {
    "no-art": "ไม่มีข้อความให้พิมพ์ — ได้เคสเปล่า",
    "thin-text": "ตัวอักษรบางมาก — บางเส้นอาจพิมพ์ไม่ติด ลองเพิ่มขนาดหรือลดจำนวนตัวอักษร",
    "same-colour": "สีลายเหมือนสีเคส ลายจะมองไม่เห็น",
    "thin-parts": "ลายมีเส้นบางที่ติดกับส่วนหนา — สไลเซอร์อาจตัดทิ้ง",
    dropped: (p) => `ตัดชิ้นที่บางเกินพิมพ์ออกจากลาย ${p.n} ชิ้น`,
    "all-thin": "ลายบางเกินไปสำหรับขนาดนี้ — ดาวน์โหลดไม่ได้",
    "art-too-complex": "ลายซับซ้อนเกินไป — ดาวน์โหลดไม่ได้",
    "wide-groove": (p) => `ร่องกว้างกว่า ${p.mm} มม. ชั้นที่ปิดร่องจะพิมพ์ลอยกลางอากาศ ผิวด้านหลังอาจไม่เรียบ ลองลดขนาดลายหรือใช้แบบเรียบ 2 สี`,
  },
  dlstl: "STL",
  copied: "คัดลอกแล้ว",
  fatal: "โหลดตัวคำนวณไม่สำเร็จ — ลองรีเฟรชหน้า",
  buildTimeout: "สร้างแบบไม่เสร็จใน 10 วินาที จึงเริ่มใหม่ — ลองลดตัวอักษรหรือเปลี่ยนฟอนต์",

  // ship 3 piece c: the template's static text, baked per language by the build (was hardcoded Thai)
  aboutH2: "เคสมือถือใส่ชื่อทำงานอย่างไร",
  aboutP1: "เลือกรุ่น iPhone 16 Pro Max หรือ iPhone 16 พิมพ์ชื่อหรือเลือกไฟล์ SVG ของโลโก้ แล้วดาวน์โหลดไฟล์ 3MF หรือ STL ไปพิมพ์ เคสพิมพ์โดยวางด้านหลังลงบนฐาน ไม่ต้องใช้ซัพพอร์ต ขอบเคสยกคลุมขอบจอเล็กน้อยเพื่อยึดเครื่อง มีช่องเว้นให้กล้อง ปุ่มด้านข้าง Camera Control และพอร์ตชาร์จ",
  aboutP2: "แบบเรียบ 2 สี ลายเป็นอีกสีหนึ่งเสมอผิวเคส ต้องใช้เครื่องพิมพ์หลายสี ส่วนแบบเซาะร่องใช้สีเดียว ไฟล์ SVG อยู่ในเครื่องของคุณ ไม่ถูกส่งไปที่ใด และไม่อยู่ในลิงก์ที่คัดลอก",
  aboutPrint: "ตัวเลขความพอดี (ช่องว่างรอบเครื่อง ความลึกของขอบ) มาจากแนวปฏิบัติของนักออกแบบรายอื่น ยังไม่เคยพิมพ์จริงและสวมกับเครื่อง ผ่านการจำลองและ slice ใน OrcaSlicer แล้วเท่านั้น",
  aboutTerms: "เครื่องมือนี้ทำไว้เพื่อการเรียนรู้และการใช้งานส่วนตัว ไม่ได้ผ่านการรับรองจากผู้ผลิตโทรศัพท์ เคสที่พิมพ์ออกมาอาจไม่พอดีหรือไม่ช่วยกันกระแทก ผู้ใช้เป็นผู้รับความเสี่ยงเองทั้งหมด",
  aboutTrademark: "iPhone เป็นเครื่องหมายการค้าของ Apple Inc. เครื่องมือนี้ไม่ใช่ของ Apple และไม่ได้เกี่ยวข้องกับ Apple ชื่อรุ่นใช้เพื่อบอกว่าเคสนี้ทำมาให้พอดีกับเครื่องรุ่นใดเท่านั้น",
};
export default S;
